import { procesingMaxDecrypt, createKeys } from '@/public/utils/decrypt-max-plugin'
import { decrypt, getModelValue } from '@/public/utils'
import Router from '@/layout/router'

export const DECRYPT_SIGN = '__inner__decrypt__'
const MASK_KEY = 'Mask'
const VIRTUAL_KEY = 'Virtual'

const isMask = (row, key) => !!row[key + MASK_KEY]
const isVirtual = (row, key) => !!row[key + VIRTUAL_KEY]

export function decryptPlugin () {
  function DECRYPT_checkMaskInRow (rowData, key) {
    // 字段如果被批量解密，mask判断有误，需判断字段是否已经批量解密
    const mask = isMask(rowData, key)
    const { keyDecryptOrder } = createKeys(key)
    const hasBatchDecrypt = rowData.hasOwnProperty(keyDecryptOrder)
    return (!hasBatchDecrypt && mask) || DECRYPT_checkVirtualInRow(rowData, key)
  }
  function DECRYPT_checkVirtualInRow(rowData, key) {
    return isVirtual(rowData, key)
  }
  function DECRYPT_beforeDecryptAction ({ rowData, column, beforeDecrypt }) {
    const { key } = column
    const mask = isMask(rowData, key)
    const virtual = isVirtual(rowData, key)
    // 2023-01-05 当用户知道字段可能存在加密或者虚拟号额情况下使用。需绕过func方法时，在解密字段前使用
    if (beforeDecrypt && typeof beforeDecrypt === 'function' && beforeDecrypt(rowData, column, { markrow: rowData, mask, virtual }) === true) {
      return false
    }
    return true
  }
  async function DECRYPT_handleDecryptAction ({
    rowData,
    column,
    data = [],
    drawColumnOptions = {},
    maxDecryptConfig,
    options,
    decryptSuccessFunc
  }) {
    const { key } = column
    if (!DECRYPT_checkMaskInRow(rowData, key)) {
      return false
    }
    const { beforeDecrypt, afterDecrypt } = drawColumnOptions[key] || {}
    const valdite = await DECRYPT_beforeDecryptAction({ rowData, column, beforeDecrypt })
    if (!valdite) {
      return
    }
    const mask = isMask(rowData, key)
    const virtual = isVirtual(rowData, key)
    const _maskKeyInRowData = `${key}${MASK_KEY}`
    const _virtualKeyInRowData = `${key}${VIRTUAL_KEY}`
    const res = await decrypt({
      dataId: getModelValue(rowData, options.bizIdKey || 'id') || '0',
      moduleCode: options.moduleCode,
      fieldName: key,
      operateReason: 'kye-decrypt',
      fieldContent: getModelValue(rowData, _maskKeyInRowData) || getModelValue(rowData, _virtualKeyInRowData),
      fieldNameStr: column.label || '',
      buttonName: Router.currentRoute.meta.title || '',
      autoFocus: false // 2022-10-28 关闭解密提示框时，不自动聚焦回canvas元素（否则部分页面会抖一下）
    }, mask ? MASK_KEY.toLowerCase() : VIRTUAL_KEY.toLowerCase())
    if (res !== null) {
      // 配置最大解密限制【maxDecryptConfig】时使用
      if (mask) {
        procesingMaxDecrypt(maxDecryptConfig, data, rowData, key, options, rowData.id)
      }
      // 金额、数据字典等解密后也需要 formatter
      // 2024-12-13 解密之后走主流程
      // rowData[key] = column.formatter ? column.formatter(rowData, column, res) : res
      rowData[key] = res
      if (mask) {
        delete rowData[_maskKeyInRowData]
      }
      if (virtual) {
        delete rowData[_virtualKeyInRowData]
      }

      if (decryptSuccessFunc && typeof decryptSuccessFunc === 'function') {
        decryptSuccessFunc({ row: rowData, markrow: rowData, key, mask: isMask, virtual, column })
      }
    }
    if (afterDecrypt) {
      typeof afterDecrypt === 'function' && afterDecrypt(rowData, column, { markrow: rowData, mask: isMask, virtual })
    }
  }
  return {
    DECRYPT_beforeDecryptAction,
    DECRYPT_handleDecryptAction,
    DECRYPT_checkMaskInRow,
    DECRYPT_checkVirtualInRow
  }
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/feature/cell-decrypt/decrypt-plugin.js